import React, { useState, useRef, useEffect } from "react";
import InputBox from "../Input/Input";
import SearchResult from "../SearchResults/SearchResult";
import { useNavigate } from "react-router-dom";

interface SearchComponentProps {
  searchResults: any[];
  handleSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  isFocusSearch?: boolean;
}

const SearchComponent: React.FC<SearchComponentProps> = ({
  searchResults,
  handleSearchChange,
  className,
  isFocusSearch,
}) => {
  const [state, setState] = useState({
    isExpand: false,
    isOpen: false,
    value: "",
    placeholder: "Search your favorite person, place, or thing",
    isFocusSearch:false
  });

  const navigate = useNavigate();
  const searchRef = useRef<HTMLDivElement>(null);

  // Handle click outside to close the search component
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        searchRef.current &&
        !searchRef.current.contains(event.target as Node)
      ) {
        setState((prev) => ({
          ...prev,
          isExpand: false,
          isOpen: false,
          placeholder: "Search your favorite person, place, or thing",
        }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  useEffect(() => {
    const handleFocus = () => {
      if (isFocusSearch !== state.isFocusSearch) {
        setState((prev) => ({
          ...prev,
          isExpand: true,
          isOpen: true,
          placeholder: "",
          isFocusSearch:!prev.isFocusSearch
        }));
      };
    }
    handleFocus();
    //eslint-disable-next-line
  }, [isFocusSearch]);

  // Handle focus inside the search input to expand it
  const handleFocus = () => {
    setState((prev) => ({
      ...prev,
      isExpand: true,
      isOpen: true,
      placeholder: "",
    }));
  };

  // Handle closing the search component when a result is clicked
  const handleResultClick = () => {
    setState((prev) => ({
      ...prev,
      isExpand: false,
      isOpen: false,
      value: "",
    }));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleSearchChange && handleSearchChange(e);
    setState((prev) => ({ ...prev, value: e.target.value }));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && state.value) {
      navigate(`/search/${state.value}`);

      setState((prev) => ({
        ...prev,
        isExpand: false,
        isOpen: false,
        value: "",
      }));
    }
  };

  return (
    <div
      id="search-section"
      ref={searchRef}
      className={`position-relative ${className} ${state.isExpand ? "expand-search-input" : "search-input"}`}
      onMouseDownCapture={handleFocus}
    >
      <div className="search-container">
        <i
          className={`fa-solid fa-magnifying-glass search-icon ${state.isExpand ? "text-dark-purple" : "text-white"
            }`}
          onClick={() => {
            setState((prev) => ({
              ...prev,
              isExpand: false,
              isOpen: false,
              value: "",
            }));
            state.value && navigate(`/search/${state.value}`);
          }}
        ></i>
        <InputBox
          type="input"
          placeholder={state.placeholder}
          className={`ps-3 form-control transition-input ${state.isOpen ? "show" : ""
            }
           ${state.isExpand
              ? "search-background expand-input-box"
              : "header-input-box bg-transparent text-white"
            }`}
          value={state.value}
          onChange={handleChange}
          onFocus={handleFocus}
          onKeyDown={handleKeyDown}
        />
      </div>
      <SearchResult
        searchResults={state.value ? searchResults : []}
        isOpen={state.isOpen}
        onResultClick={handleResultClick}
      />
    </div>
  );
};

export default SearchComponent;
